//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../../library/umum.js'
import WILAYAH from  '../../../../library/getWilayah'
import FETCHING from  '../../../../library/fetching'
import CHART from  '../../../../library/chart'
import uniqid from 'uniqid';


export default {
  data() {
    return {

      form : {
        id : '',
        des_kel : '',
        tahun : '',
      },
     
      list_data : [],

      page_limit : 14,
      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,

    }
  },
  methods: {


    getView : async function(){
      var body = this.form
      this.list_data = await CHART.postDataPublish('LayananKesehatan', body);
      console.log(this.list_data)
    },


    btnAdd(){
      this.$router
    },

  

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


     



    // ====================================== PAGINATE ====================================



  },

  mounted () {
    this.form.tahun = UMUM.getTahun();
    WILAYAH.getListDesKelFull();
    this.getView();
    // FETCHING.getJenisUsaha();


    
  },
}
